import { createFileRoute } from '@tanstack/react-router';
import { GradeSubmissionScreen } from '@/quiz-submission/GradeSubmissionScreen';

/**
 * The member mount of the grade screen — new, and not a convenience duplicate.
 * On a congregation or custom study group the group pending table renders ZERO
 * row actions (`Actions/Submissions/Grade.php:18` and `ViewProgress.php:17`
 * both return false when the group is not a study group; measured, group 578
 * returned `actions=''` on all six rows), so this is the ONLY grading entry
 * point on 9 of 18 staging groups.
 *
 * Legacy's member template is a one-line `require` of the group template
 * (`themes/wbs/buddypress/members/single/course-study/quiz_grade.php:1`), so the
 * form itself lives in `@/quiz-submission/` and both mounts share it — including
 * R34's refusal ("You do not have permission to grade this quiz.",
 * `quizzes/grade.php:16`), which has no admin arm and is a screen rule rather
 * than a gate.
 *
 * R30 — `$memberId` is decorative; authorization is on the grading. Measured
 * live: `/members/1613/.../grade/880` renders grading 880, which belongs to
 * student 1918.
 */
export const Route = createFileRoute(
  '/_app/_users/members/$memberId/course-study/quizzes/grade/$submissionId',
)({
  component: MemberQuizSubmissionGradeScreen,
});

function MemberQuizSubmissionGradeScreen() {
  const { submissionId } = Route.useParams();
  return (
    <GradeSubmissionScreen submissionId={Number.parseInt(submissionId, 10)} />
  );
}
